// Web mixpanel implementation

import mixpanel from "mixpanel-browser";
import config from "./config";

mixpanel.init(config.mixpanel, { debug: true });
export const analytics = mixpanel;
